// src/contexts/YearContext.js
import React from 'react';

export const YearContext = React.createContext();
